import Phaser from "phaser";
import { GameConstants } from "../GameConstants";
import { GameManager } from "../GameManager";

export class BootScene extends Phaser.Scene {
    private failed = false;

    constructor() { super("BootScene"); }

    public preload(): void {
        this.failed = false;
        this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, this.onLoadError, this);
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
            this.load.off(Phaser.Loader.Events.FILE_LOAD_ERROR, this.onLoadError, this);
        });
        this.load.image("catafractum-logo", "assets/catafractum-logo.png");
    }

    public create(): void {
        GameManager.setCurrentScene(this);
        if (this.failed) {
            this.add.text(this.scale.width / 2, this.scale.height / 2, "Could not load the logo.\nClick to retry.", {
                fontFamily: "sans-serif", fontSize: "24px", color: GameConstants.TEXT_COLOR, align: "center"
            }).setOrigin(.5).setInteractive({ useHandCursor: true })
                .once(Phaser.Input.Events.POINTER_UP, () => this.scene.restart());
            return;
        }
        GameManager.init();
    }

    private onLoadError(file: Phaser.Loader.File): void {
        console.error("Could not load Catafractum logo", file.key, file.url);
        this.failed = true;
    }
}
